export const black = "#000";
export const deepBlue = "#242979";

export const lightBlue = "#464BA3";
export const white = "#fff";

export const gray = "#ccc";
export const lightGray = "#D0D0CE";

export const transparentGray = "#00000029";
export const transparentBlack = "#000000AA";
export const transparentWhite = "#ffffffAA";

export const teal = "#048099";
export const lightTeal = "#EFF9FF";
export const darkTeal = "#02607C";

export const gold = "#F1B434";
export const maroon = "#991E66";

export const blueTealGradient = `linear-gradient(0.25turn, ${lightBlue}, ${teal})`;
export const tealGradientVertical = `linear-gradient(0.5turn, ${teal}, ${darkTeal})`;
export const blueGradient = `linear-gradient(0.25turn, ${lightBlue}, ${deepBlue})`;
export const blueGradientVertical = `linear-gradient(0.5turn, ${lightBlue}, ${deepBlue})`;
export const lightTealGradientVertical = `transparent linear-gradient(180deg, ${lightTeal} 0%, ${white} 100%) 0% 0% no-repeat padding-box;`;
